import { render, staticRenderFns } from "./Introduce.vue?vue&type=template&id=ce925180&scoped=true"
import script from "./Introduce.vue?vue&type=script&lang=ts&setup=true"
export * from "./Introduce.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Introduce.vue?vue&type=style&index=0&id=ce925180&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce925180",
  null
  
)

export default component.exports